angular.module('am4')
.factory('profileService', function($q, $http, UserService, apiUrl) {
    return {
        getSettings: function getSettings() {
            return UserService.user.then(function userGetSettings(res) {
                return {
                    email: res.email,
                    display_name: res.nickname,
                    language: res.language,
                    unit_preference: res.unit_preference
                };
            });
        },
        updateSettings: function updateSettings(user_id, settings) {
            var safeUser = encodeURIComponent(user_id),

                updates = [
                    $http.put(apiUrl + '/users/' + safeUser + '/email', {
                        email: settings.email
                    }),
                    $http.put(apiUrl + '/users/' + safeUser + '/display_name', {
                        display_name: settings.display_name
                    }),
                    $http.put(apiUrl + '/users/' + safeUser + '/language', {
                        language: settings.language
                    }),
                    $http.put(apiUrl + '/users/' + safeUser + '/unit_preference', {
                        unit_preference: settings.unit_preference
                    })
                ];

            if (angular.isDefined(settings.roles)) {
                updates.push($http.put(apiUrl + '/users/' + safeUser + '/roles', settings.roles));
            }

            return $q.all(updates);
        },
        updatePassword: function updatePassword(user_id, new_password, old_password) {
            var safeUser = encodeURIComponent(user_id);

            return $http.put(apiUrl + '/users/' + safeUser + '/password', {
                new_password: new_password,
                old_password: old_password
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/profile.js